module.exports = __webpack_public_path__ + "img/cursos-primary.de19e77c.svg";